module.exports = __webpack_public_path__ + "img/60.7.Chla.b66e55f0.png";